import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { KycReviewStatusService } from '../../../onboarding/services/kyc-review-status.service';
import { OnboardingStatusService } from '../../../onboarding/services/onboarding-status.service';
import { KycNotificationService } from '../../services/kyc-notification.service';

/**
 * Header bell + dropdown panel listing the FR-7 KYC review in-app notifications.
 * Visible to company admins and authorized signatories who can start KYC re-reviews.
 */
@Component({
  selector: 'app-notification-bell',
  imports: [TranslocoPipe],
  templateUrl: './notification-bell.html',
  styleUrl: './notification-bell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBellComponent {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly onboardingStatus = inject(OnboardingStatusService);
  private readonly kycReviewStatusService = inject(KycReviewStatusService);
  protected readonly notificationStore = inject(KycNotificationService);

  protected readonly canManageKycReview = this.onboardingStatus.canManageKycReview;
  protected readonly isOpen = signal(false);

  protected togglePanel(): void {
    const next = !this.isOpen();
    this.isOpen.set(next);
    if (next) {
      this.notificationStore.markAllAsRead();
    }
  }

  protected onActionClicked(): void {
    if (!this.canManageKycReview()) return;
    this.kycReviewStatusService.startReReview();
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  protected onDocumentClick(event: MouseEvent): void {
    if (this.isOpen() && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen.set(false);
    }
  }
}
